export default "__VITE_ASSET__7a7f694d__"